<script>
import {emitirDeclaracaoDeAcessoAoVeiculo} from '../../../../domain/grv/services/index'
import { isArray } from 'lodash'
import {VueMaskDirective as mask} from 'v-mask'
import createDownloadLink from '../../../../utils/create-download-link'

export default {
  components: {},
  nome: 'declaracao-acesso-veiculo-form',
  props: {
    grv: {
      type: Object
    }
  },
  directives: {mask},
  data () {
    return {
      isLoading: false,
      isLoaded: true,
      cadastroError: null,
      atualizadoSucesso: null,
      data: {
        nome: null,
        rg: null,
        cpf: null,
        numeroAcesso: null,
        listaItens: []
      },
      editNumeroAcesso: false
    }
  },
  created () {
    this.data.numeroAcesso = (this.grv.numeroAcessoDeclaracao || 0) + 1
  },
  activated () {
  },
  destroyed () {
  },
  watch: {},
  methods: {
    submit () {
      this.cadastroError = null
      this.atualizadoSucesso = false
      this.$parent.loading(true)
      this.$bar.start()

      this.data.listaItens = this.data.listaItens.filter(item => item && item.trim().length)

      emitirDeclaracaoDeAcessoAoVeiculo(this.grv.id, this.data).then((response) => {
        let callbackEnd = () => {
          this.$bar.finish()
          createDownloadLink(response.data, `declaracao_acesso_veiculo_grv_${this.grv.numero}.pdf`)
          this.$emit('finishSubmit', true)
        }
        callbackEnd()
      }).catch((response) => {
        this.$bar.finish()
        this.cadastroError = response.data.errors
        this.$nextTick(() => {
          this.$refs.error.focus()
        })
        console.log(response)
      })
      .finally(() => {
        this.$parent.loading(false)
      })
    },
    printError (err) {
      if (isArray(err)) {
        return err[0]
      }
      return err
    }
  }
}
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-12"><h1 class="m-n font-thin h3">Dados do Proprietário ou Representante Legal</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome" required />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">RG</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.rg" required/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">CPF</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cpf" required v-mask="'###.###.###-##'"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Número de acesso</label>
                <div class="col-sm-3">
                  <input type="number" min="0" class="form-control" required v-model="data.numeroAcesso" :disabled="!editNumeroAcesso"/>
                </div>
                <div class="col-sm-5" style="display: flex; align-items: center;">
                  <input type="checkbox" v-model="editNumeroAcesso">
                  <label class="control-label m-l-sm">Editar número de acesso</label>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Lista de Itens</label>
                <div class="col-sm-8">
                  <div class="row m-b-sm" v-for="(item, key) in data.listaItens" :key="key" style="display: flex; align-items: center">
                    <div class="col-sm-10">
                      <input type="text" class="form-control" required v-model.trim="data.listaItens[key]" />
                    </div>
                    <div class="col-sm-2">
                      <u-button @click="data.listaItens.splice(key, 1)" class="btn-link btn-xs">
                        <i class="fa fa-times text-danger"></i>
                      </u-button>
                    </div>
                  </div>
                  <u-button @click="data.listaItens.push('')" class="btn btn-info btn-xs">
                    <i class="fa fa-plus"></i> Adicionar Item</u-button>
                </div>
              </div>
              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button @click="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$emit('finishSubmit')">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// DeclaracaoAcessoVeiculoForm.vue?6a751a86